import { trackCustomEvent } from '../Config/DataDog';
import UCL from '../Helpers/UserClientLibs';
import useLogout from './_LogoutService';
const handleLogout = useLogout();

const post = async (url, body) => {
    var headers = {
        'Content-Type': 'application/json',
        'X-Token': await UCL.GetIdTokenValidatedAsync(),
        'Authorization': await UCL.BuildBearerAccessTokenAsync()
    };

    return fetch(`${url}`, {
        method: 'POST',
        mode: 'cors',
        headers,
        body: JSON.stringify(body),
    }).then(handle);
};

const postWithHeaders = async (url, body, headers) => {

    return fetch(`${url}`, {
        method: 'POST',
        mode: 'cors',
        headers,
        body: JSON.stringify(body),
    }).then(handle);
};

const getWithHeaders = async (url, headers) => {

    let urlObject = new URL(url);

    return fetch(`${urlObject}`, {
        method: 'GET',
        mode: 'cors',
        headers,
    }).then(handle);
};

const get = async (url, params) => {
    var headers = {
        'Content-Type': 'application/json',
        'X-Token': await UCL.GetIdTokenValidatedAsync(),
        'Authorization': await UCL.BuildBearerAccessTokenAsync()
    };
    let urlObject = new URL(url);

    if (params) {
        urlObject.search = new URLSearchParams(params).toString();
    }

    return fetch(`${urlObject}`, {
        method: 'GET',
        mode: 'cors',
        headers,
    }).then(handle);
};

const handle = (response) => {
    if (response.ok) {
        return response.json();
    } else {
        return new Promise((resolve, reject) => {
            let message;
            switch (response.status) {
                case 401:
                    trackCustomEvent("logout", true, { message: `ApiService - ${error.message}`});
                    handleLogout();
                    message = `Se requiere autenticación. Por favor ingrese sus credenciales nuevamente - (status code: ${response.status})`;
                    break;
                case 402:
                    trackCustomEvent("api-service-error", true, { message: `ApiService - ${error.message}`});
                    break;
                case 403:
                    trackCustomEvent("api-service-error", true, { message: `ApiService - ${error.message}`});
                    message = `No posee los permisos necesarios para acceder al recurso solicitado. Por favor ingrese sus credenciales nuevamente - (status code: ${response.status})`;
                    break;
                case 404:
                    message = `No existe el recurso solicitado. Por favor intentelo nuevamente más tarde - (status code: ${response.status})`;
                    break;
                case 400:
                case 500:
                case 'parsererror':
                case 'timeout':
                case 'abort':
                case 0:
                default:
                    trackCustomEvent("api-service-error", true, { message: `ApiService - ${error.message}`});
                    message =
                        'Ocurrió un error inesperado. Por favor intentelo nuevamente más tarde.';
            }
            reject(message);
        });
    }
};

export default { post, get, postWithHeaders, getWithHeaders };
